var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMyLeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40,34.75A6.75,6.75,0,1,0,33.25,28,6.75738,6.75738,0,0,0,40,34.75Zm0-12A5.25,5.25,0,1,1,34.75,28,5.25574,5.25574,0,0,1,40,22.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.75,62V44A6.75738,6.75738,0,0,0,46,37.25H34A6.75738,6.75738,0,0,0,27.25,44V62h1.5V44A5.25574,5.25574,0,0,1,34,38.75H46A5.25574,5.25574,0,0,1,51.25,44V62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29.25A5.75,5.75,0,1,0,24.75,35,5.75671,5.75671,0,0,0,19,29.25Zm0,10A4.25,4.25,0,1,1,23.25,35,4.25507,4.25507,0,0,1,19,39.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75,49A4.25507,4.25507,0,0,1,15,44.75h9v-1.5H15A5.75671,5.75671,0,0,0,9.25,49V62h1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61,40.75A5.75,5.75,0,1,0,55.25,35,5.75671,5.75671,0,0,0,61,40.75Zm0-10A4.25,4.25,0,1,1,56.75,35,4.25507,4.25507,0,0,1,61,30.75Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.75,62V49A5.75671,5.75671,0,0,0,65,43.25H56v1.5h9A4.25507,4.25507,0,0,1,69.25,49V62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyLeader);
export default __webpack_public_path__ + "static/media/icon_my_leader.272287f05fe8aa1e8fc83350b1e43e21.svg";
export { ForwardRef as ReactComponent };